import React from 'react'
import './policy.css'
import useDocumentTitle from '../useDocumentTitle.js';

export default function TermsAndConditions() {
  window.scrollTo(0, 0);
  useDocumentTitle("Terms and Conditions")

  return (
    <div className='policy'>
      <div>
        <h1>Terms and Conditions</h1>
        <p>Last updated: 10 January 2026</p>
      </div>

      <p>
        These Terms and Conditions govern your use of services provided by Vrajpath Itech LLP, a software development and service-based company offering SaaS products, digital platforms, and technology solutions.
      </p>

      <h2>Definitions</h2>
      <ul>
        <li><strong>Company</strong> refers to Vrajpath Itech LLP, Address - Eccosphere Coworking, Block B, Sector-67, Noida, Uttar Pradesh 201309, India.</li>
        <li><strong>Services</strong> include software development, SaaS platforms, mobile applications, web applications, and related digital services.</li>
        <li><strong>Platform</strong> refers to our website, mobile applications, and software systems.</li>
        <li><strong>User</strong> means any individual or business accessing or using the Services.</li>
      </ul>

      <h2>Acceptance of Terms</h2>
      <p>
        By accessing or using our Services, you agree to be bound by these Terms. If you do not agree, you must not use our Services.
      </p>

      <h2>Eligibility</h2>
      <p>
        You must be at least 18 years old to use our Services. By using the platform, you confirm that you meet this requirement.
      </p>

      <h2>Use of Services</h2>
      <ul>
        <li>You agree not to misuse the platform or engage in illegal activities.</li>
        <li>You must provide accurate and complete information.</li>
        <li>You are responsible for maintaining account confidentiality.</li>
      </ul>

      <h2>Service Scope</h2>
      <p>
        Vrajpath Itech LLP provides digital services including SaaS products, custom software development, and technology solutions. Service availability, features, and pricing may change at any time.
      </p>

      <h2>Payments & Subscriptions</h2>
      <ul>
        <li>Some services require payment or subscription.</li>
        <li>Payments are processed via third-party gateways.</li>
        <li>Subscriptions may auto-renew unless cancelled.</li>
        <li>Pricing is subject to change with prior notice.</li>
      </ul>

      <h2>Intellectual Property</h2>
      <p>
        All content, software, and intellectual property on the platform belong to Vrajpath Itech LLP. Unauthorized use or reproduction is strictly prohibited.
      </p>

      <h2>Service Availability</h2>
      <p>
        We strive to provide uninterrupted service but do not guarantee that services will always be available or error-free.
      </p>

      <h2>Limitation of Liability</h2>
      <p>
        Vrajpath Itech LLP shall not be liable for any indirect, incidental, or consequential damages arising from the use of our Services.
      </p>

      <h2>Termination</h2>
      <p>
        We reserve the right to suspend or terminate your access if you violate these Terms.
      </p>

      <h2>Third-Party Services</h2>
      <p>
        Our platform may include third-party integrations. We are not responsible for their services or policies.
      </p>

      <h2>Governing Law</h2>
      <p>
        These Terms are governed by the laws of India. Any disputes shall be subject to the jurisdiction of courts in Ghaziabad, Uttar Pradesh.
      </p>

      <h2>Changes to Terms</h2>
      <p>
        We may update these Terms at any time. Continued use of the Services implies acceptance of the updated Terms.
      </p>

      <h2>Contact Us</h2>
      <ul>
        <li>Email: support@vrajpath.com</li>
        <li>Website: <a href="https://www.vrajpath.com" target="_blank" rel="noopener noreferrer">https://www.vrajpath.com</a></li>
        <li>Phone: +91-9818527999</li>
      </ul>
    </div>
  )
}